import React, { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import { connect } from 'react-redux'
import { obtenerCargasBuque } from '../../actions/TablaCargaBuquesActions'
import { cerealesColor } from '../../../../config/cereales'
import CalendarioControles from '../../components/anunciobuques/CalendarioControles'
import ListadoBuquesCalendario from '../../components/anunciobuques/ListadoBuquesCalendario'
import { INTERVALO_ACTUALIZACION } from '../../../../config/settings'
import { COLORES } from '../../../../config/colores'

function CalendarioCargas (props) {
  const { obtenerCargasBuque, cargasAnunciadas, availableCereals, cerealFiltro, fechaFiltro, exportadorProyeccion } = props
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [selectedCereales, setSelectedCereales] = useState(availableCereals)
  const [buquesFiltrados, setBuquesFiltrados] = useState([])
  useEffect(() => {
    obtenerCargasBuque()

    const interval = setInterval(() => {
      obtenerCargasBuque()
    }, [INTERVALO_ACTUALIZACION])

    return () => {
      clearInterval(interval)
    }
  }, [obtenerCargasBuque])

  useEffect(() => {
    handleCerealFilter(availableCereals)
  }, [availableCereals])

  useEffect(() => {
    if (cerealFiltro === 'TODOS') {
      setSelectedCereales(availableCereals)
    } else {
      setSelectedCereales([cerealFiltro])
    }
  }, [cerealFiltro, availableCereals])

  useEffect(() => {
    if (typeof fechaFiltro === 'string' && fechaFiltro.includes('/')) {
      const partes = fechaFiltro.split('/')
      const dateObjeto = new Date(partes[2], partes[1] - 1, partes[0])
      setSelectedDate(dateObjeto)
    } else {
      setSelectedDate(fechaFiltro)
    }
  }, [fechaFiltro])

  useEffect(() => {
    const buquesFiltrados = cargasAnunciadas.filter((carga) => selectedCereales.includes(carga.claveCereal.trim()) && (!exportadorProyeccion || parseInt(exportadorProyeccion) === carga.exportador))
    setBuquesFiltrados(buquesFiltrados)
  }, [cargasAnunciadas, selectedCereales, exportadorProyeccion, setBuquesFiltrados])

  const handleCerealFilter = (cereales) => {
    setSelectedCereales(cereales)
  }

  const obtenerCargaPorDia = (date) => {
    const dateString = date && date.toISOString().split('T')[0]
    return buquesFiltrados.filter((buque) => buque.fechaDeCarga === dateString)
  }

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const diasCarga = obtenerCargaPorDia(date)
      if (diasCarga.length > 0) {
        return (
          <div className='ship-indicators'
            style={{
              maxWidth: '100%',
              padding: '10px 6px',
              background: 'none',
              border: 'none',
              textAlign: 'center',
              lineHeight: '16px',
              fontSize: '0.8rem',
              position: 'relative',
              transition: 'all 0.2s'
            }}
          >
            {diasCarga.slice(0, 3).map((carga) => (
              <div
                key={carga.id}
                className={`ship-dot`}
                style={{ backgroundColor: cerealesColor[(carga.claveCereal).trim()] }}
                title={`${carga.buque} - ${carga.cereal.toUpperCase()}`}
              />
            ))}
            {diasCarga.length > 3 && <div className='ship-more'>+{diasCarga.length - 3}</div>}
          </div>
        )
      }
    }
    return null
  }

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const diasCarga = obtenerCargaPorDia(date)
      if (diasCarga.length > 0) {
        return 'Hay cargas anunciadas'
      }
    }
    return null
  }

  const buquesPorDia = obtenerCargaPorDia(selectedDate)

  return (
    <div className='ship-card' >
      <h6 style={{
        padding: '5px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: COLORES.grey.mediumDark
      }}
      >
        Embarque proyectado
      </h6>
      <CalendarioControles
        selectedCereales={selectedCereales}
        onCerealFilter={handleCerealFilter}
        cargasAnunciadas={cargasAnunciadas}
        buquesFiltrados={buquesFiltrados}
        cereales={availableCereals}
      />

      <Calendar
        onChange={setSelectedDate}
        value={selectedDate}
        tileContent={tileContent}
        tileClassName={tileClassName}
        locale='es-ES'
        next2Label={null}
        prev2Label={null}
        showNeighboringMonth={false}
      />

      <div className='selected-day-info'>
        {buquesPorDia && buquesPorDia.length > 0 &&
          <h3>
            {selectedDate.toLocaleDateString('es-ES', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </h3>
        }
        <ListadoBuquesCalendario buques={buquesPorDia} />
      </div>

    </div>
  )
}

const mapStateToProps = (state) => ({
  cargasAnunciadas: state.buque.cargasAnunciadas,
  availableCereals: state.buque.cargasAnunciadasCereales,
  cerealFiltro: state.buque.cerealFiltro,
  fechaFiltro: state.buque.fechaCargaFiltro,
  exportadorProyeccion: state.stock.exportadorProyeccion
})

const mapActionsToProps = {
  obtenerCargasBuque
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(CalendarioCargas)
